"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfDateIsBetweenAndIsWeekday = exports.checkIfDateIsBetween = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const checkWeekdays = (date, weekdays) => {
  const currentDate = new Date(date);
  const numberDayWeek = [6, 0, 1, 2, 3, 4, 5];
  let currentDayOfWeek = currentDate.getDay();
  return (weekdays & 1 << numberDayWeek[currentDayOfWeek]) > 0;
};
const checkIfDateIsBetween = (from, to) => {
  return (0, _moment.default)(new Date()).isBetween(from, to, undefined, "[]");
};
exports.checkIfDateIsBetween = checkIfDateIsBetween;
const checkIfDateIsBetweenAndIsWeekday = (date, from, to, weekdays) => {
  return (0, _moment.default)(date).isBetween(from, to, undefined, "[]") && checkWeekdays(date, weekdays);
};
exports.checkIfDateIsBetweenAndIsWeekday = checkIfDateIsBetweenAndIsWeekday;